import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sla, kpi, slaInteraction, kpiInteraction, slakpiInteraction, kpiViewDashBoard, slakpiMapping, year, quater, filecontent, kpiRelease, kpitarget, kpiband, slaperformance, slakpiperformance, kpiWithTarget, kpiInbox, kpiViewComment, kpiViewWorkFlow, kpiViewHistory, slaIssueList, slakpidatabase, kpiNotification, slakpiMappingArchive, kpiUserActivities, kpiBulkCopy, kpiReset, benchmarkkpi, tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpientry, benchmarkkpirelease, practicebmtransactionadd, benchmarkkpiposition, bmincoming, surveyOptionMaster, surveyOptionEntry, surveyQuestionMaster, surveyQuestionEntry, bmincomingattendees, bmdashboardFilterValue, BMProjectActions, BMIncomingSurveyEntry, bmsurveyQAList, BMProjectActionsHistory, annualPerformanceBM, annualPracticeBM, bmIncomingDashBoard, BMProjectApprovalHistroy, annualOutingVisit, outgoingBMRequest, bmRequest, incomingBMRequest, practiceBMGranttChart, bmsurveyQuestion, bmRequestStatusHistroy, bmInOutGoingStatusHistroy, bmoutgoing, annualStatusHistroy, bmOutgoingDashBoard, recentUpdates, dashboardContentEntry, dashboardChart, bmKPIPerformanceTrend, annualNomination, kpiDynamic, bmKPIPostionDashboard, kpiDashboard_MoroDigitalInfra, performanceDashBoard, actionPlanDetail, actionPlanDetailHistory, actionPlan, kpidelegate, kpiDelegateUpdate} from './../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster, fileManager } from './../models/admin';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SLAKPIApiService {
  // Define API
    headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
  apiURL = environment.apiBase; //'http://localhost:52180/';
  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  private GetHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    }
  }
  httpOptions_file = {
    headers: new HttpHeaders({
      'Authorization': 'Bearer ' + this.jwtToken()
    })
  };
  httpOptions_file_download = {
    responseType: "blob",
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.jwtToken()
    })
  }
  //JWT token access
  private jwtToken() {

    var struser = localStorage.getItem('accessinfo');
    if (struser) {
      let currentAccess = JSON.parse(struser);
      // create authorization header with jwt token           
      if (currentAccess && currentAccess.token) {
        //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        return currentAccess.token;
      }
    }
  }
 
  

  // Error handling 
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  //  API SLA Start here---------------------------------//
   

  public getSLAs(objSLA: sla) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLA', objSLA, this.GetHttpOptions());
  }

  public addEditSLA(objSLA: sla) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateSLA', objSLA, this.GetHttpOptions());
  }

  SLAFileUpload(fileToUpload: any, fname: string, slaNo: string) {

    let formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("name", slaNo + "#" + fname);
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers };
    return this.http.post(this.apiURL + '/api/SLAKPI/SLA_FileUpload', formData, options)
  }
  public GET_FileUpload_Headers() {
    return this.jwtToken();
  }
  public SLA_FileUpload(fileToUpload:any,SLAUno:string) {
    let formData = new FormData();
    //formData.append("file", fileToUpload);
    formData.append("SLAID", SLAUno);  
    return this.http.post(this.apiURL + '/api/SLAKPI/SLA_FileUpload', formData, this.httpOptions_file);
  }
  public SLA_FileDelete(objSLA: filecontent) {
    return this.http.post(this.apiURL + '/api/SLAKPI/SLA_FileDelete', objSLA, this.GetHttpOptions());
  }
  public SLA_FileSelect(objSLA: filecontent) {
    return this.http.post(this.apiURL + '/api/SLAKPI/SLA_FileSelect', objSLA, this.GetHttpOptions());
  }
  public SLA_Filedownload(objSLA: filecontent): Observable<any> {
    return this.http.post(this.apiURL + '/api/SLAKPI/SLA_Filedownload', objSLA, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }
  public deleteSLA(objSLA: sla) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteSLA', objSLA, this.GetHttpOptions());
  }
  public getSLATypes(objSLATypes: sla) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAType', objSLATypes, this.GetHttpOptions());
  }
 
  //  API SLA End here---------------------------------//

  
  //  API KPI Start here---------------------------------//


  public getKPIs(objKPI: kpi) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPI', objKPI, this.GetHttpOptions());
  }

  public addEditKPI(objKPI: kpi) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPI', objKPI, this.GetHttpOptions());
  }
  public deleteKPI(objKPI: kpi) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteKPI', objKPI, this.GetHttpOptions());
  }
  public getKPITypes(objSLATypes: kpi) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAType', objSLATypes, this.GetHttpOptions());
  }

  KPIFileUpload(fileToUpload: any, fname: string, kpiNo: string) {

    let formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("name", kpiNo + "#" + fname);
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers };
    return this.http.post(this.apiURL + '/api/SLAKPI/KPI_FileUpload', formData, options)
  }
 
  
  public KPI_FileDelete(objKPI: filecontent) {
    return this.http.post(this.apiURL + '/api/SLAKPI/KPI_FileDelete', objKPI, this.GetHttpOptions());
  }
  public KPI_FileSelect(objKPI: filecontent) {
    return this.http.post(this.apiURL + '/api/SLAKPI/KPI_FileSelect', objKPI, this.GetHttpOptions());
  }
  public KPI_Filedownload(objKPI: filecontent): Observable<any> {
    return this.http.post(this.apiURL + '/api/SLAKPI/KPI_Filedownload', objKPI, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }

  //  API KPI End here---------------------------------//

  //SLA Interaction
  public getSlaInteractions(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAInteraction', objsla, this.GetHttpOptions());
  }

  public addSlaInteractions(objsla: slaInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertSLAInteraction', objsla, this.GetHttpOptions());
  }
  public deleteSlaTransaction(objSLA: slaInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteSLAInteraction', objSLA, this.GetHttpOptions());
  }
 
  //KPI Interaction
  public getKpiInteractions(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIInteraction', objsla, this.GetHttpOptions());
  }

  public addKpiInteractions(objsla: kpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertKPIInteraction', objsla, this.GetHttpOptions());
  }

  public deleteKpiInteractions(objsla: kpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteKPIInteraction', objsla, this.GetHttpOptions());
  }

  public getUsers(objDepartment: user) {
    return this.http.post(this.apiURL + '/api/Admin/GetUser', objDepartment, this.GetHttpOptions());
  }

  public getDivisions(objDivision: division) {
    return this.http.post(this.apiURL + '/api/Admin/GetDivision', objDivision, this.GetHttpOptions());
  }
  public getDepartments(objDepartment: department) {
    return this.http.post(this.apiURL + '/api/Admin/GetDepartment', objDepartment, this.GetHttpOptions());
  }

  public GetTargetInfo(objDepartment: targetMaster) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetTargetInfo', objDepartment, this.GetHttpOptions());
  }

  //SLA&KPI Mapping
  public getSLAKPIMappings(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIMapping', objsla, this.GetHttpOptions());
  }
  public getSLAKPIMappingsHistory(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIMappingHistory', objsla, this.GetHttpOptions());
  }
 
  public addSLAKPIMappings(objsla: slakpiMapping) {
    return this.http.post(this.apiURL + '/api/SLAKPI/AddSLAKPIMapping', objsla, this.GetHttpOptions());
  }
  public addSLAKPIMappingsArchive(objsla: slakpiMappingArchive) {
    return this.http.post(this.apiURL + '/api/SLAKPI/AddSLAKPIMappingArchive', objsla, this.GetHttpOptions());
  }
  public getYearMaster(objyear: year) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetYearMaster', objyear, this.GetHttpOptions());
  }
  public getKPITranFilterValues(objyear: year) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPITranFilterValues', objyear, this.GetHttpOptions());
  }
  
  public getYearMasterAll(objTenant: year) {
    return this.http.post(this.apiURL + '/api/Admin/GetYearMasterTenant', objTenant, this.GetHttpOptions());
  }
  public getQuaterMaster(objquater: quater) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetQuaterMaster', objquater, this.GetHttpOptions());
  }
  public deleteslaKpiMappings(objsla: slakpiMapping) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteSLAKPIMapping', objsla, this.GetHttpOptions());
  }

  //KPI Release

  public getKpiRelease(objkpi: kpiRelease) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIRelease', objkpi, this.GetHttpOptions());
  }
  public getKpiReleaseCount(objkpi: kpiRelease) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIReleaseCount', objkpi, this.GetHttpOptions());
  }
  
  public addKpiRelease(objkpi: kpiRelease) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertKPIRelease', objkpi, this.GetHttpOptions());
  }

  public addKpiMissingBand(objkpi: kpiRelease) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertKPIMissingBand', objkpi, this.GetHttpOptions());
  }

  public addKpiReset(objkpi: kpiReset) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertKPIReset', objkpi, this.GetHttpOptions());
  }

  public getKpiInbox(objkpi: kpiInbox) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIInbox', objkpi, this.GetHttpOptions());
  }
  public getKpiInboxCount(objkpi: kpiInbox) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIInboxFilterCount', objkpi, this.GetHttpOptions());
  }

  public getKpiYearWiseChart(objkpi: kpiInbox) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIYearWiseChart', objkpi, this.GetHttpOptions());
  }

  

  //sla performance
  public getSlaPerformance(objslaper: slaperformance) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAPerformance', objslaper, this.GetHttpOptions());
  }
  //slakpi performance
  public getSlaKpiPerformance(objslakpiper: slakpiperformance) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIPerformance', objslakpiper, this.GetHttpOptions());
  }

  //sla issue list
  public getSlaIssueList(objslaIssue: slaIssueList) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAIssueList', objslaIssue, this.GetHttpOptions());
  }

  //slakpi database
  public getSlaKpiDatabase(objslakpi: slakpidatabase) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIDatabase', objslakpi, this.GetHttpOptions());
  }
  public sendReminderKPI(objslakpi: slakpidatabase) {
    return this.http.post(this.apiURL + '/api/SLAKPI/SendReminderKPI', objslakpi, this.GetHttpOptions());
  }
  public sendBenchmarkReminderKPI(objslakpi: any) {
    return this.http.post(this.apiURL + '/api/SLAKPI/sendBenchmarkReminderKPI', objslakpi, this.GetHttpOptions());
  }

  //kpi target
  public addKpiTarget(objkpiTarget: kpitarget) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPITarget', objkpiTarget, this.GetHttpOptions());
  }
  public getKpiTargets(objkpiTarget: kpitarget) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPITarget', objkpiTarget, this.GetHttpOptions());
  }


  //benchmark kpi target
  public addBenchmarkTarget(objkpiTarget: kpitarget) {

    return this.http.post(this.apiURL + '/api/SLAKPI/addBenchmarkTarget', objkpiTarget, this.GetHttpOptions());
  }
  public getBenchmarkTargets(objkpiTarget: kpitarget) {
    return this.http.post(this.apiURL + '/api/SLAKPI/getBenchmarkTargets', objkpiTarget, this.GetHttpOptions());
  }
  public bulkBenchmarkKPITargetProcess(objkpi: kpiBulkCopy) {
    return this.http.post(this.apiURL + '/api/SLAKPI/bulkBenchmarkKPITargetProcess', objkpi, this.GetHttpOptions());
  }

  //kpi band
  public addKpiBand(objkpiBand: kpiband) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPIBand', objkpiBand, this.GetHttpOptions());
  }
  public getKpiBands(objkpiBand: kpiband) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIBand', objkpiBand, this.GetHttpOptions());
  }
  public getKpiWithTarget(objkpiWithTarget: kpiWithTarget) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIWithTarget', objkpiWithTarget, this.GetHttpOptions());
  }

  //Kpi View

  public getKpiCodeDetails(objkpi: kpiInbox) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPICodeDetails', objkpi, this.GetHttpOptions());
  }

  public getKpiViewComments(objkpi: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIViewComment', objkpi, this.GetHttpOptions());
  }
  public getKpiReminderComments(objkpi: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIReminderComments', objkpi, this.GetHttpOptions());
  }
  public getKpiDynamicsTransaction(objkpi: kpiDynamic) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIDynamicsTransaction', objkpi, this.GetHttpOptions());
  }
  public getKpiDynamicsAttachment(objkpi: kpiDynamic) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetMstKPIDynamicAttachments', objkpi, this.GetHttpOptions());
  }
  public deleteKpiDynamicsAttachment(objkpi: kpiDynamic) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteMstKPIDynamicAttachments', objkpi, this.GetHttpOptions());
  }
  public kpiDynamicsAttachmentUpload(objkpi: any) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DynamicEntry_FileUpload', objkpi, this.httpOptions_file);
  }
  public getKpiViewIssue(objkpi: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIViewIssue', objkpi, this.GetHttpOptions());
  }
  public getKpiViewJustification(objkpi: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIViewJustification', objkpi, this.GetHttpOptions());
  }
  public getKpiViewKPIWorkflow(objkpi: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIViewKPIWorkflow', objkpi, this.GetHttpOptions());
  }

  public getInddividualKpiViewKPIWorkflow(objkpi: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetIndividualKPIViewKPIWorkflow', objkpi, this.GetHttpOptions());
  }
  public getKPITargetValueHistory(objkpi: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPITargetValueHistory', objkpi, this.GetHttpOptions());
  }
 
  public getkpiViewHistory(objkpi: kpiViewHistory) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIViewHistory', objkpi, this.GetHttpOptions());
  }

  public getkpiViewBand(objkpi: kpiband) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetViewKPIBand', objkpi, this.GetHttpOptions());
  }

  public addKpiViewComment(objkpiViewComment: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPIViewComment', objkpiViewComment, this.GetHttpOptions());
  }

  public addKpiViewWorkflow(objkpiViewWorkflow: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPIViewWorkFlow', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public addAdminKpiViewWorkflow(objkpiViewWorkflow: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateAdminKPIViewWorkFlow', objkpiViewWorkflow, this.GetHttpOptions());
  }

  public bulkUpdateKpiViewWorkflow(objkpiViewWorkflow: kpiViewWorkFlow) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/BulkInsertUpdateKPIViewWorkFlow', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public addKpiIssue(objkpiViewWorkflow: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPIIssue', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public updateKpiIssue(objkpiViewWorkflow: slaIssueList) {
    return this.http.post(this.apiURL + '/api/SLAKPI/UpdateKPIIssue', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public updateKpiIssueDescription(objkpiViewWorkflow: slaIssueList) {
    return this.http.post(this.apiURL + '/api/SLAKPI/UpdateKPIIssueDescription', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public loadKpiIssue(objkpiViewWorkflow: kpiViewWorkFlow) {
    return this.http.post(this.apiURL + '/api/SLAKPI/LoadKPIIssue', objkpiViewWorkflow, this.GetHttpOptions());
  }
  public getkpiIssueComment(objkpi: slaIssueList) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIIssueComment', objkpi, this.GetHttpOptions());
  }
  ////kpi Dashboard
  public getKPIDashboard(objkpiViewDashBoard: kpiViewDashBoard) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIDashboard', objkpiViewDashBoard, this.GetHttpOptions());
  }
  public getSLAKPIDashboard(objkpiViewDashBoard: kpiViewDashBoard) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIDashboard', objkpiViewDashBoard, this.GetHttpOptions());
  }
  public getPerformanceDashboard(objkpiViewDashBoard: performanceDashBoard) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetPerformanceDashboard', objkpiViewDashBoard, this.GetHttpOptions());
  }
  public getKPINotification(objkpiViewDashBoard: kpiNotification) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPINotification', objkpiViewDashBoard, this.GetHttpOptions());
  }
  public getKpiUserActivities(objkpi: kpiUserActivities) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetUserActivities', objkpi, this.GetHttpOptions());
  }
  public bulkKPITargetProcess(objkpi: kpiBulkCopy) {
    return this.http.post(this.apiURL + '/api/SLAKPI/BulkKPITargetProcess', objkpi, this.GetHttpOptions());
  }
  public bulkKPIBandProcess(objkpi: kpiBulkCopy) {
    return this.http.post(this.apiURL + '/api/SLAKPI/BulkKPIBandProcess', objkpi, this.GetHttpOptions());
  }

  public getKPIDashboard_MoroDigitalInfra(obj: kpiDashboard_MoroDigitalInfra) {

    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIDashboard_MoroDigitalInfra', obj, this.GetHttpOptions());
  }


  //Api for Action Plan
  public getActionPlan(objActionPlan: actionPlan) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetActionPlan', objActionPlan, this.GetHttpOptions());
  }

  public addEditActionPlan(objActionPlan: actionPlan) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateActionPlan', objActionPlan, this.GetHttpOptions());
  }

  public deleteActionPlan(objActionPlan: actionPlan) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteActionPlan', objActionPlan, this.GetHttpOptions());
  }

  //Api for Action Plan Detail
  public getActionPlanDetail(objActionPlan: actionPlanDetail) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetActionPlanDetail', objActionPlan, this.GetHttpOptions());
  }

  public addEditActionPlanDetail(objActionPlan: actionPlanDetail) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateActionPlanDetail', objActionPlan, this.GetHttpOptions());
  }

  public deleteActionPlanDetail(objActionPlan: actionPlanDetail) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteActionPlanDetail', objActionPlan, this.GetHttpOptions());
  }

  //Api for Action Plan Detail
  public getActionPlanDetailHistory(objActionPlan: actionPlanDetailHistory) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetActionPlanDetailHistory', objActionPlan, this.GetHttpOptions());
  }

  public getSlaIssueDashboard(obj: slaIssueList) {

    return this.http.post(this.apiURL + '/api/SLAKPI/getSlaIssueDashboard', obj, this.GetHttpOptions());
  }

  //KPI Mapping
  public getKPIMappings(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIMapping', objsla, this.GetHttpOptions());
  }

  public addKPIMappings(objsla: slakpiMapping) {
    return this.http.post(this.apiURL + '/api/SLAKPI/AddKPIMapping', objsla, this.GetHttpOptions());
  }

  public getKPI(objKPI: kpi) {
    
    return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIs', objKPI, this.GetHttpOptions());
  }

  public deleteKpiMappings(objsla: slakpiMapping) {
    return this.http.post(this.apiURL + '/api/SLAKPI/DeleteKPIMapping', objsla, this.GetHttpOptions());
  }
  public getSlaKpiFollowUp(objslakpi: slakpidatabase) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetSLAKPIDatabase', objslakpi, this.GetHttpOptions());
  }
 
  public GetTrnKPIFollowUp(objsla: year) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetTrnKPIFollowUp', objsla, this.GetHttpOptions());
  }

  // KPI Delegation

  public getDelegateKpi(objkpi: kpidelegate) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetDelegateKPI', objkpi, this.GetHttpOptions());
  }
  public getDelUsers(objDepartment: user) {
    return this.http.post(this.apiURL + '/api/Admin/GetDelegateUser', objDepartment, this.GetHttpOptions());
  }
  public updateKpiDelegation(objKPIDelegate: kpiDelegateUpdate[]) {
    return this.http.post(this.apiURL + '/api/SLAKPI/InsertUpdateKPIDelegate', objKPIDelegate, this.GetHttpOptions());
  }
  public getDelegation(objKPIDelegate: kpiDelegateUpdate) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetDelegation', objKPIDelegate, this.GetHttpOptions());
  }
  public getUserKPIs(objKPI: kpi) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetUserKPI', objKPI, this.GetHttpOptions());
  }

  public manualRevertDelegation(objKPI: kpiDelegateUpdate) {
    return this.http.post(this.apiURL + '/api/SLAKPI/ManualRevertDelegation', objKPI, this.GetHttpOptions());
  }
}
